import Vue from 'vue';
import { pushDataInternalBanner } from 'lib/tracking';
import {Autoplay, Navigation, Pagination, Keyboard, A11y} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    el,
    data: () => {
      return {
        ...el.dataset,
        swiperOptions: {
          slidesPerView: 1,
          autoplay: el.dataset.autoplay > 0 ? { delay: el.dataset.autoplay } : false,
          rewind: true,
          a11y: true,
          keyboard: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return `<button class="${className}"></button>`;
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          modules: [Autoplay, Navigation, Pagination, Keyboard, A11y],
        }
      };
    },
    methods: {
      goToDetail(url, promoName) {
        pushDataInternalBanner(url, promoName);
      },
    },
  });
